import React, { useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
// import { AuthServices } from "../../services/AuthService";
import { AuthContext } from "../../Context/AuthContext";
import { Link, useHistory } from "react-router-dom";
import { ApiService } from "../../services/ApiService";
import { useAlert } from "react-alert";

export const forgot_Password = () => {
  const { login } = useContext(AuthContext);
  const [loader, setLoader] = useState(false);
  const load = (
    <span id="login_spinner" className="fa fa-spin fa-spinner"></span>
  );
  const alert = useAlert();
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="login-reg-panel"></div>

      <div className="login-white-panel">
        <div className="login-show">
          <center>
            <div className="logo-img">
              <a href="/">
                <img
                  src="/img/Needle_logo.png"
                  width="191px"
                  alt="needlelogo"
                  height="42px"
                />
              </a>
              <br></br>
              <small></small>
            </div>
          </center>
          <Formik
            initialValues={{ email: "" }}
            validate={(values) => {
              const errors = {};
              if (!values.email) {
                errors.email = "Required";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Invalid email address";
              }
              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              setLoader(true);
              ApiService.post("password/forgot/", values)
                .then((res) => {
                  if (res.data.success === true) {
                    alert.success("Reset password email sent successfully");
                    history.push("/login");
                  }
                })
                .catch((error) => {
                  console.log("heel 2");
                  alert.error("Incorrect email");
                  setLoader(false);
                });
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group mt-5">
                  <Field
                    type="email"
                    name="email"
                    className="form-control mt-5"
                    placeholder="Email"
                  />

                  <ErrorMessage name="email" component="div" />
                </div>

                <div className="text-center">
                  <Link to="/" className="text-dark">
                    Already have an account? Login
                  </Link>
                </div>
                <span className="clearfix"></span>

                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn btn-block nt-button-color-default btn-sm"
                  >
                    {loader ? load : "Submit"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <div className="login-reg-panel-image"></div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/auth/forget_password.js